import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/InformationmarkSmallCircle.tsx
const InformationmarkSmallCircleIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M10.5 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM11 10v8h2v-8h-2Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
		fill: props.fill || "currentColor"
	})]
}));
export { InformationmarkSmallCircleIcon };
